import React, { useContext } from "react";
import classNames from "classnames";
import {
    BankIcon,
    BusinessIcon,
    PlusIcon,
    TriangleIcon,
} from "../../../../icons";
import { Button } from "../../../general/Button/Button";
import {
    RuleSource,
    TransactionRuleGroup,
} from "../../../../common/types/transactionRule";
import { TransactionRuleCreationContext } from "../../../transactionRules/TransactionRuleCreation/TransactionRuleCreation.context";
import styles from "../RulesTable.module.scss";

/**
 * GroupHeaderCell renders the group title and drag handle.
 */
interface GroupHeaderCellProps {
    readonly group: TransactionRuleGroup;
    readonly groupListeners?: React.HTMLAttributes<HTMLElement>;
    readonly groupAttributes?: React.HTMLAttributes<HTMLElement>;
    rowSpan?: number;
    readonly toggleCollapse?: () => void;
    readonly isCollapsed?: boolean;
}

const GroupIcon = ({ icon }: { icon: string }) => {
    if (icon === "briefcase") {
        return <BusinessIcon />;
    }

    if (icon === "bank") {
        return <BankIcon />;
    }

    return null;
};

export const GroupHeaderCell: React.FC<GroupHeaderCellProps> = ({
    group,
    // groupListeners,
    // groupAttributes,
    rowSpan,
    toggleCollapse,
    isCollapsed,
}) => {
    const { createRule } = useContext(TransactionRuleCreationContext);

    return (
        <td
            className={classNames(styles.td, styles.groupHeader)}
            rowSpan={rowSpan ?? group.rules?.length ?? 1}
        >
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-2 align-items-center">
                    <div
                        className={classNames(
                            "d-flex gap-buttons align-items-center",
                            styles.grayIcon,
                        )}
                    >
                        <GroupIcon icon={group.icon} />
                        <span>{group.name}</span>
                    </div>

                    {toggleCollapse && (
                        <Button
                            icon
                            size="sm"
                            variant="tertiary"
                            className={classNames(styles.visibleOnHover, {
                                [styles.collapsedCarot]: isCollapsed,
                            })}
                            onClick={() => toggleCollapse()}
                        >
                            <TriangleIcon />
                        </Button>
                    )}
                </div>
                <Button
                    size="sm"
                    icon
                    variant="tertiary"
                    tooltip="Add rule"
                    onClick={() => {
                        createRule({
                            source: RuleSource.SETTINGS,
                            definition: {
                                groupId: group.id,
                                conditions: [],
                                actions: [],
                            },
                        });
                    }}
                >
                    <PlusIcon />
                </Button>
                {/* <Button
                {...groupListeners}
                {...groupAttributes}
                size="sm"
                icon
                variant="tertiary"
                tabIndex={-1}
                aria-label="Drag group"
                className={styles.dragButton}
                style={{ marginLeft: 8 }}
            >
                <DragHandle6DotIcon />
            </Button> */}
            </div>
            {group.isDefault && (
                <span className={styles.defaultRulesDescription}>
                    {group.isAccounting
                        ? "Map transactions to the Chart of Accounts"
                        : "Customize transaction categories and entities"}
                </span>
            )}
        </td>
    );
};
